import { StyledInput } from '../../Atoms'
import { StyledSVG } from '../../Atoms/SVG/styles'
import { styled } from '../../Styles/stitches.config'

export const StyledSearch = styled('div', {
    position: 'relative',

    [`& ${StyledInput}`]: {
        px: 'calc($4 + $3)',
    },

    [`& ${StyledSVG}`]: {
        color: '$neutral400',
        cursor: 'pointer',
        position: 'absolute',
        size: 20,
        top: '50%',
        transform: 'translateY(-50%)',
        transition: '$default',
    },
})
